import { Container, Button, Testimonials, SEO } from "@/components";
import { Hero } from "@/components";
import { CheckCircle } from "lucide-react";
import { services, homeStructuredData } from "@/data";
import styles from "./Home.module.css";

const Home = () => {
  const handleCardClick = () => {
    window.location.href = '/gallery';
  };

  return (
    <>
      <SEO
        title="Brevard County's Leading Concrete Contractor"
        description="H&W Concrete specializes in residential and commercial concrete projects in Brevard County, Florida. Expert concrete driveways, patios, sidewalks, and custom work. Free estimates. Call (321) 208-0016 today."
        keywords="concrete contractor, concrete driveways, concrete patios, concrete sidewalks, Brevard County, Florida, concrete services, concrete construction, concrete paving, concrete slabs, garage slabs, pool decks, concrete contractor near me"
        url="/"
        structuredData={homeStructuredData}
      />
      
      {/* Hero Section */}
      <Hero
        title="H&W Concrete is Brevard County Florida's leading concrete expert."
        subtitle="Servicing all of your residential and commercial needs."
        backgroundImage="./img/hero4.png"
      >
        <Button href="/gallery" variant="primary" size="lg">
          See Our Projects
        </Button>
        <Button href="/contact" variant="secondary" size="lg">
          Contact Us
        </Button>
      </Hero>

      {/* Why Choose Us Section */}
      <section className={styles.whyChooseUs}>
        <Container>
          <div className={styles.whyChooseUsContent}>
            <h2 className={styles.sectionTitle}>Why Choose Us?</h2>
            <div className={styles.whyChooseUsGrid}>
              <div className={styles.whyChooseUsImage}>
                <img
                  src="./img/why_us_section.jpg"
                  alt="Why choose H&W Concrete - Professional concrete work in Brevard County"
                />
              </div>
              <div className={styles.whyChooseUsFeatures}>
                <div className={styles.feature}>
                  <div className={styles.featureHeader}>
                    <div className={styles.featureIcon}>
                      <CheckCircle size={24} color="var(--blue-9)" />
                    </div>
                    <h5>Versatility</h5>
                  </div>
                  <div className={styles.featureContent}>
                    <p>
                      Our team is experienced, skilled, and flexible—bringing
                      our customers&apos; ideas to life no matter the size and scope
                      of work.
                    </p>
                  </div>
                </div>
                <div className={styles.feature}>
                  <div className={styles.featureHeader}>
                    <div className={styles.featureIcon}>
                      <CheckCircle size={24} color="var(--blue-9)" />
                    </div>
                    <h5>Honesty</h5>
                  </div>
                  <div className={styles.featureContent}>
                    <p>
                      Our reputation is the foundation of our business. We
                      believe our customers&apos; needs should always be met with
                      fairness and sincerity.
                    </p>
                  </div>
                </div>
                <div className={styles.feature}>
                  <div className={styles.featureHeader}>
                    <div className={styles.featureIcon}>
                      <CheckCircle size={24} color="var(--blue-9)" />
                    </div>
                    <h5>Reliability</h5>
                  </div>
                  <div className={styles.featureContent}>
                    <p>
                      We deliver quality work within schedule. Every time. With
                      no exceptions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Services Section */}
      <section className={styles.services}>
        <Container>
          <div className={styles.servicesContent}>
            <h2 className={styles.sectionTitle}>Our Services</h2>
            <div className={styles.servicesGrid}>
              {services.map((service) => (
                <div 
                  key={service.id} 
                  className={styles.serviceCard}
                  onClick={handleCardClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleCardClick();
                    }
                  }}
                >
                  <img
                    src={service.image}
                    alt={`${service.title} - H&W Concrete Brevard County`}
                    className={styles.cardImg}
                  />
                  <div className={styles.cardBody}>
                    <h5 className={styles.cardTitle}>{service.title}</h5>
                    <p className={styles.cardText}>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* Testimonials Section */}
      <Testimonials />
    </>
  );
};

export default Home;
